import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  OrganizationOngoingSurveysCount = 'OrganizationOngoingSurveysCount',
}

export const useGetOrganizationOngoingSurveysCountQuery = () => {
  const { getOrganizationOngoingSurveysCount } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.OrganizationOngoingSurveysCount],
    queryFn: () => getOrganizationOngoingSurveysCount(),
    refetchInterval: 60000,
  });
};
